import { FrontendContextService } from './../../../../services/front-end-context/front-end-context.service';
import { Router } from '@angular/router';
import { Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { ScrollToService } from 'root/services';

import { ResourceStringComponent } from 'root/shared/components/localization/resource-string/resource-string.component';


@Component({
  selector: 'mibp-dashboard-partscatalog',
  templateUrl: './dashboard-title-partscatalog.component.html',
  styleUrls: ['./dashboard-title-partscatalog.component.scss', './../../modules/dashboard/pages/temporary-tiles.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ResourceStringComponent]
})
export class DashboardTitlePartscatalogComponent {
  private router = inject(Router);
  private frontendContext = inject(FrontendContextService);
  private scroll = inject(ScrollToService);


  @Input() placeHeaderOnTop = false;

  constructor() { }

  onclick() {
    this.router.navigateByUrl(this.frontendContext.Navigation.ensureUrlLanguage('/myfleet/electronic-manuals'));
    this.scroll.scrollToTop();
  }
}
